import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function Level_detail() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = "";    

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("224466");

  const [position, setPosition] = useState("0");
  const [Level, setLevel] = useState("0");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  let arrayLeft = [];
  //   let value = 2
  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: search,
          report: "mylevel",
          fdate: formdate,
          tdate: todate,
          status: "2",
          level: Level,
          Position: position,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("Direct team", responceRight?.data?.data);
      // console.log("Direct team Output", responceRight?.data?.dataOutput);
      // setTotalId(responceRight?.data?.dataOutput?.totalid);
      // setTotalAmount(responceRight?.data?.dataOutput?.totalamount);
      responceRight = responceRight?.data?.data?.[0];
      setleftreferralApi([]);

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item?.RowNumber,
          uid: item?.uid,
          sid: item?.sid,
          f_name: item?.f_name,
          joinningdate: item?.joinningdate,
         IDstatus: <span className={item?.IDstatus =="Active" ? "text-success" : "text-danger"}>{item?.IDstatus}</span> ,
          currentPackage: item?.currentPackage,
          totalPackage:  item?.packagename +' USD',
          Leveltype: item?.Leveltype,
          activationDate: item?.ActivationDate,
          position: item?.position,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Wallet Address", accessor: "f_name" },
      { Header: "Registration Date", accessor: "joinningdate" },
      // { Header: "Position", accessor: "position" },
      { Header: "Package", accessor: "totalPackage" },
      { Header: "Level", accessor: "Leveltype" },
      { Header: "Status", accessor: "IDstatus" },
      { Header: "Activation Date", accessor: "activationDate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Level Details</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="userid"
                        ng-model="p.userid"
                        class="form-control in-ip-1"
                        placeholder="Enter User Id"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    {/* <div class="col-md-2">
                      <select
                        class="form-control in-ip-1"
                        id="SelectLevel"
                        onChange={(e) => setPosition(e.target.value)}
                        name="SelectLevel"
                      >
                        <option value="0">All</option>
                        <option value="1">Left</option>
                        <option value="2">Right</option>
                      </select>
                    </div> */}
                    <div class="col-md-2">
                      <select
                        class="form-control in-ip-1"
                        id="SelectLevel"
                        onChange={(e) => setLevel(e.target.value)}
                        name="SelectLevel"
                      >
                        <option value="">Select Level</option>
                        <option value="0">All</option>
                        <option value="1">Level 1</option>
                        <option value="2">Level 2</option>
                        <option value="3">Level 3</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromdate(new Date(e.target.value))}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTodate(e.target.value)}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>

                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <h4>
                      <span></span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Level_detail;
